import "./SbbPersona.scss";

import classNames from "classnames";
import { Highlight } from "components/Highlight";
import { getInitials } from "helpers";
import { createLogger } from "logging";
import { useLayout } from "providers";
import React from "react";

import { SbbPersonaImage } from "./SbbPersonaImage";

const logger = createLogger("SbbPersona");

export interface SbbPersonaProps {
  title?: string;
  size?: number;
  subTitle?: string;
  profileImage?: string;
  initials?: string;
  initialsColor?: string;
  personnelNumber?: string;
  disabled?: boolean;
  className?: string;
  highlight?: string;
  tooltip?: string;
  url?: string;
}

export const SbbPersona: React.FC<SbbPersonaProps> = ({
  title,
  subTitle,
  profileImage,
  size = 24,
  initials,
  initialsColor,
  disabled,
  highlight,
  tooltip,
  url,
  className,
}) => {
  const { handleNavClick } = useLayout();

  title = `${title || ""}`.trim();
  subTitle = `${subTitle || ""}`.trim();
  initials = `${initials || ""}`;
  initialsColor = `${initialsColor || ""}`;

  logger.trace("render():", title, subTitle, initials, initialsColor, profileImage);
  if (!initials) {
    initials = getInitials(title, false, { firstInitialOnly: size <= 16 });
  }

  if (!initialsColor) initialsColor = "#0078d7";

  const wrapperClassName = classNames(
    "ms-Persona",
    url ? "ms-Persona--pointer" : "",
    `ms-Persona--${size}`,
    disabled ? "ms-Persona--Disabled" : "",
    className,
    tooltip ? "global-tooltip-trigger" : ""
  );

  return (
    <div
      className={wrapperClassName}
      title={tooltip}
      onClick={() => {
        if (url) handleNavClick(url);
      }}
    >
      <SbbPersonaImage profileImage={profileImage} title={title} initials={initials} initialsColor={initialsColor} />

      {title && (
        <div className="ms-Persona-title">
          <Highlight content={title} highlight={highlight} />
        </div>
      )}

      {subTitle && (
        <div className="ms-Persona-secondaryText">
          <Highlight content={subTitle} highlight={highlight} />
        </div>
      )}
    </div>
  );
};
